// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"hotel_page_sliderContainer__kpvG8","floatingSearchContainer":"hotel_page_floatingSearchContainer__2QRHp"};